export const settings_redeem_code_en = {
  redeem_code: "Redeem Code",
  settings_redeem_code_title: "Redeem Promotional Code",
  settings_redeem_code_desc:
    "Enter your promotional code below to claim additional credits, discounts, or special rewards tied to your organization. Codes may be provided through campaigns, partnerships, or limited-time offers. Once redeemed, the benefits will be applied directly to your account.",
  setting_redeem_code_promotional_code_title: "Promotional Code",
  setting_redeem_code_promotional_code_desc:
    "Have a promo code? Redeem it here to get your extra benefits instantly.",
  settings_redeem_code_input_placeholder: "Enter promotional code",
  settings_redeem_code_success:
    "Promo code applied successfully! You’ve received 0 credits. | Promo code applied successfully! You’ve received 1 credit. | Promo code applied successfully! You’ve received {0} credits.",
  redeem: "redeem",
  redeem_another_code: "Redeem another code",
  change_code: "Change code",
};


export const settings_redeem_code_zhCN = {
  redeem_code: "兑换码",
  settings_redeem_code_title: "兑换促销代码",
  settings_redeem_code_desc:
    "在下方输入您的促销代码，以领取与您组织相关的额外积分、折扣或特殊奖励。代码可能通过营销活动、合作伙伴关系或限时优惠提供。兑换后，福利将直接应用到您的账户。",
  setting_redeem_code_promotional_code_title: "促销代码",
  setting_redeem_code_promotional_code_desc:
    "有促销代码吗？在此兑换即可立即获得额外福利。",
  settings_redeem_code_input_placeholder: "输入促销代码",
  settings_redeem_code_success:
    "促销代码应用成功！您已获得0积分。| 促销代码应用成功！您已获得1积分。| 促销代码应用成功！您已获得{0}积分。",
  redeem: "兑换",
  redeem_another_code: "兑换其他代码",
  change_code: "更改代码"
};


export const settings_redeem_code_zhTW = {
  redeem_code: "兌換碼",
  settings_redeem_code_title: "兌換促銷代碼",
  settings_redeem_code_desc:
    "在下方輸入您的促銷代碼，以領取與您組織相關的額外點數、折扣或特殊獎勵。代碼可能透過行銷活動、合作夥伴關係或限時優惠提供。兌換後，福利將直接應用到您的帳戶。",
  setting_redeem_code_promotional_code_title: "促銷代碼",
  setting_redeem_code_promotional_code_desc:
    "有促銷代碼嗎？在此兌換即可立即獲得額外福利。",
  settings_redeem_code_input_placeholder: "輸入促銷代碼",
  settings_redeem_code_success:
    "促銷代碼應用成功！您已獲得0點數。| 促銷代碼應用成功！您已獲得1點數。| 促銷代碼應用成功！您已獲得{0}點數。",
  redeem: "兌換",
  redeem_another_code: "兌換其他代碼",
  change_code: "更改代碼"
};

export const settings_redeem_code_ja = {
  redeem_code: "引き換えコード",
  settings_redeem_code_title: "プロモーションコードの引き換え",
  settings_redeem_code_desc:
    "以下にプロモーションコードを入力して、組織に関連する追加クレジット、割引、または特別な特典を請求してください。コードはキャンペーン、パートナーシップ、または期間限定オファーを通じて提供される場合があります。引き換え後、特典は直接あなたのアカウントに適用されます。",
  setting_redeem_code_promotional_code_title: "プロモーションコード",
  setting_redeem_code_promotional_code_desc:
    "プロモーションコードをお持ちですか？ここで引き換えて追加特典を即座に獲得しましょう。",
  settings_redeem_code_input_placeholder: "プロモーションコードを入力",
  settings_redeem_code_success:
    "プロモーションコードが正常に適用されました！0クレジットを獲得しました。| プロモーションコードが正常に適用されました！1クレジットを獲得しました。| プロモーションコードが正常に適用されました！{0}クレジットを獲得しました。",
  redeem: "引き換える",
  redeem_another_code: "別のコードを引き換える",
  change_code: "コードを変更"
};

export const settings_redeem_code_ko = {
  redeem_code: "리딤 코드",
  settings_redeem_code_title: "프로모션 코드 사용",
  settings_redeem_code_desc:
    "아래에 프로모션 코드를 입력하여 조직과 연결된 추가 크레딧, 할인 또는 특별 보상을 받으세요. 코드는 캠페인, 파트너십 또는 한정 기간 오퍼를 통해 제공될 수 있습니다. 사용 후 혜택이 직접 귀하의 계정에 적용됩니다.",
  setting_redeem_code_promotional_code_title: "프로모션 코드",
  setting_redeem_code_promotional_code_desc:
    "프로모션 코드가 있으신가요? 여기에서 사용하여 추가 혜택을 즉시 받으세요.",
  settings_redeem_code_input_placeholder: "프로모션 코드 입력",
  settings_redeem_code_success:
    "프로모션 코드가 성공적으로 적용되었습니다! 0크레딧을 받았습니다.| 프로모션 코드가 성공적으로 적용되었습니다! 1크레딧을 받았습니다.| 프로모션 코드가 성공적으로 적용되었습니다! {0}크레딧을 받았습니다.",
  redeem: "사용",
  redeem_another_code: "다른 코드 사용",
  change_code: "코드 변경"
};

export const settings_redeem_code_hi = {
  redeem_code: "रिडीम कोड",
  settings_redeem_code_title: "प्रोमोशनल कोड रिडीम करें",
  settings_redeem_code_desc:
    "अतिरिक्त क्रेडिट, छूट, या विशेष पुरस्कार प्राप्त करने के लिए नीचे अपना प्रोमोशनल कोड दर्ज करें। कोड अभियानों, साझेदारी, या सीमित समय के ऑफर के माध्यम से प्रदान किए जा सकते हैं। एक बार रिडीम होने के बाद, लाभ सीधे आपके खाते में लागू हो जाएंगे।",
  setting_redeem_code_promotional_code_title: "प्रोमोशनल कोड",
  setting_redeem_code_promotional_code_desc:
    "कोई प्रोमो कोड है? इसे यहां रिडीम करें और तुरंत अतिरिक्त लाभ प्राप्त करें।",
  settings_redeem_code_input_placeholder: "प्रोमोशनल कोड दर्ज करें",
  settings_redeem_code_success:
    "प्रोमो कोड सफलतापूर्वक लागू हुआ! आपने 0 क्रेडिट प्राप्त किए।| प्रोमो कोड सफलतापूर्वक लागू हुआ! आपने 1 क्रेडिट प्राप्त किया।| प्रोमो कोड सफलतापूर्वक लागू हुआ! आपने {0} क्रेडिट प्राप्त किए।",
  redeem: "रिडीम करें",
  redeem_another_code: "दूसरा कोड रिडीम करें",
  change_code: "कोड बदलें"
};